"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var SuccessMark = function SuccessMark(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    className: className,
    icon: _freeSolidSvgIcons.faCheckCircle
  });
};

SuccessMark.propTypes = {
  className: _propTypes.default.string
};

var _default = (0, _styledComponents.default)(SuccessMark).withConfig({
  displayName: "SuccessMark",
  componentId: "bxqkhr-0"
})(["font-size:19px;color:#658d30;margin-right:10px;"]);

exports.default = _default;